/**
 * Created by xuyq on 2021/3/29.
 */
import {baseProxy,settings} from '@/myops/core'

export default class dataProxy extends baseProxy{
    constructor(request) {
        super(request);
        this.user = null;
    }
    async login({eid,password}){
        let formData = new FormData();
        formData.append('eid',eid)
        formData.append('password',password)
        let {data:{code,data,msg} = {}} = await this.request({
            url:"/api/login.json",
            method:"post",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data:formData
        })

        if(code=== '200'){
            return data
        } else {
            throw new Error(msg);
        }
    }
    async getUserInfo(){
        let {data} = await this.request({
            url:"/api/getUserInfo.json",
            method: 'get'
        })
        this.user = data
        return data
    }
    async getDicByArray(catagroyArray){
        let {data:{code,data,msg}} = await this.request({
            url:settings.request.sys_prefix+"api/manage/dic/getDic",
            params: {dicType: catagroyArray.join(',')},
            method: 'get'
        })
        if(code=== 200){
            return data
        } else {
            throw new Error(msg);
        }
    }
    async getPermission(moduleName){
        let permission = this.user.permission||[]
        let permissionList = []
        permission.permissionMenus.forEach(t=>{
            permissionList.push({repositoryId:t.menuId})
        })

        permission.permissionRepositories.forEach(t=>{
            permissionList.push({repositoryId:t.repositoryId})
        })
        return permissionList
    }
}
